module.exports = __webpack_public_path__ + "static/media/agefis-logo.67f50df3.png";